import styled, { keyframes } from "styled-components";
import { promoteLayer } from "./utils";

interface IDropdownRootProps {
  $animatingOut?: boolean;
  direction?: string;
  $duration: number;
}

const getDropdownRootKeyFrame = ({
  $animatingOut,
  direction,
}: IDropdownRootProps) => {
  if (!$animatingOut && direction) return null;
  return keyframes`
  from {
    transform: ${$animatingOut ? "rotateX(0)" : "rotateX(-15deg)"};
    opacity: ${$animatingOut ? 1 : 0};
  }
  to {
    transform: ${$animatingOut ? "rotateX(-15deg)" : "rotateX(0)"};
    opacity: ${$animatingOut ? 0 : 1};
  }
`;
};

export const DropdownRoot = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "$animatingOut" && prop !== "direction",
})<IDropdownRootProps>`
  transform-origin: 0 0;
  ${promoteLayer}
  animation-name: ${getDropdownRootKeyFrame};
  animation-duration: ${(props) => props.$duration}ms;
  /* use 'forwards' to prevent flicker on leave animation */
  animation-fill-mode: forwards;
  /* flex styles will center the caret child component */
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  top: -20px;
`;

export const Caret = styled.div`
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent var(--background-color);
  /* make sure it's above the main dropdown container so now box-shadow bleeds over it */
  z-index: 1;
  position: relative;
  /* prevent any gap in between caret and main dropdown */
  top: 1px;
`;

export const DropdownBackground = styled.div`
  transform-origin: 0 0;
  background-color: var(--background-color);
  border-radius: 24px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1);
  ${promoteLayer}
`;

interface IAltBackgroundProps {
  $duration: number;
}

export const AltBackground = styled.div<IAltBackgroundProps>`
  background-color: var(--background-secondary);
  width: 300%;
  height: 100%;
  position: absolute;
  top: 0;
  left: -100%;
  transform-origin: 0 0;
  z-index: 0;
  transition: transform ${(props) => props.$duration}ms;
`;

interface IInvertedDivProps {
  absolute?: boolean;
}

export const InvertedDiv = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "absolute",
})<IInvertedDivProps>`
  ${promoteLayer}
  position: ${(props) => (props.absolute ? "absolute" : "relative")};
  top: 0;
  left: 0;
  &:first-of-type {
    z-index: 1;
  }
  &:not(:first-of-type) {
    z-index: -1;
  }
`;
